import { render } from "./Snackbar.vue?vue&type=template&id=4e58c7e0&scoped=true"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=4e58c7e0&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e58c7e0"]])

export default __exports__